import { PriorityResponse, TicketConfigClient, TicketPriorityDescriptionRequest } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';

export const getTicketPriorityDescsAction = () => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.getPriorityDescs(tenantId);
}

export const updateTicketPriorityDescsAction = (priorityDescription: TicketPriorityDescriptionRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.updatePriorityDescs(tenantId, priorityDescription);
}

export const getTicketPriorityAction = () => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.getPriorites(tenantId);
}

export const persistTicketPriorityAction = async () => {
	const state = store.getState();

	if (state.persistedTicketPriority.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getTicketPriorityAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const TICKET_PRIORITY_FETCHING = 'TICKET_PRIORITY_FETCHING';
export const TICKET_PRIORITY_SET = 'TICKET_PRIORITY_SET';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: TICKET_PRIORITY_FETCHING,
		fetching
	}
}

const setAction = (items: PriorityResponse[]): PersistItemsActionType<PriorityResponse> =>  {
	return {
		type: TICKET_PRIORITY_SET,
		items
	}
}
